//Add lozad intersection observer polyfill for older browsers
require('intersection-observer');

//Load JS Cookie
const Cookies = require('js-cookie');

//Load basicLightbox as a module
const basicLightbox = require('basiclightbox');

//Add native bootstrap components we need only
import Modal from 'bootstrap.native/dist/components/modal-native.esm.js'
import Tab from 'bootstrap.native/dist/components/tab-native.esm.js'
import Tooltip from 'bootstrap.native/dist/components/tooltip-native.esm.js'
import Dropdown from 'bootstrap.native/dist/components/dropdown-native.esm.js'
import Collapse from 'bootstrap.native/dist/components/collapse-native.esm.js'

//Add siema for quote/tweets slider
import Siema from 'siema/dist/siema.min.js'

//Add sal for html animations
import sal from 'sal.js/dist/sal.js'

//Add lozad for lazy loading images and videos:
import lozad from 'lozad'

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

//Smooth scroll for the Trust Center page
import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.min.js'
var scroll = new SmoothScroll('a[href*="#"]');

let lang = window.navigator.languages ? window.navigator.languages[0] : null;
  lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;

  let shortLang = lang;
  if (shortLang.indexOf('-') !== -1)
      shortLang = shortLang.split('-')[0];

  if (shortLang.indexOf('_') !== -1)
      shortLang = shortLang.split('_')[0];

  //Try to automatically send FR/DE/ES traffic to their home page unless they specified a lang pref
  if(window.location.pathname === '/') {
    if (typeof Cookies.get('langPref') == 'undefined') {
      if (shortLang !== 'en') {
        if(shortLang === 'fr')
          window.location = '/fr/';
        if(shortLang === 'es')
          window.location = '/es/';
        if(shortLang === 'de')
          window.location = '/de/';
      }
    } else {
      if(Cookies.get('langPref') === 'lang-fr')
        window.location = '/fr/';
      if(Cookies.get('langPref') === 'lang-es')
        window.location = '/es/';
      if(Cookies.get('langPref') === 'lang-de')
        window.location = '/de/';
    }
  }


document.addEventListener('DOMContentLoaded', function(e) {

  //asign lightbox to a tags with basic-lightbox class
  let lightbox = document.querySelector('a.basic-lightbox');
  if(lightbox) {
    document.querySelector('a.basic-lightbox').onclick = (event) => {
      event.preventDefault();
      let imgsrc = event.target.href;
      basicLightbox.create('<img src="'+imgsrc+'">').show();
    }
  }
  //assign cookie for lang pref to overide home page auto redirect away from EN
  const langTriggers = document.querySelectorAll('#langDropdown + .dropdown-menu a.dropdown-item')
  for (const langTrigger of langTriggers) {
    langTrigger.addEventListener('click', function(event) {
      Cookies.set('langPref', this.id);
    });
  }

  //lazy load wistia js
  const wistiaTriggers = document.querySelectorAll('.wistia_embed button,.wistia_embed .button')
  if(wistiaTriggers) {
    window._wq = window._wq || [];
    for (const wistiaTrigger of wistiaTriggers) {
      wistiaTrigger.addEventListener('click', function(event) {
        var ev1 = document.createElement('script');
        ev1.src = '//fast.wistia.com/assets/external/E-v1.js';
        ev1.async = true;
        ev1.charset = 'ISO-8859-1';
        document.head.appendChild(ev1); 

        let videoId = event.target.dataset.wistiaId;

        _wq.push({ 
          id: videoId, onReady: function(video) {
            video.play();
          }
        });
      });
    }
  }

  //force wistia load if wvideo param is set
  const urlParams = new URLSearchParams(window.location.search);
  const wistiaParam = urlParams.get('wvideo');
  if(wistiaParam) {
    console.log(wistiaParam);
    var qv1 = document.createElement('script');
    qv1.src = '//fast.wistia.com/assets/external/E-v1.js';
    qv1.async = true;
    qv1.charset = 'ISO-8859-1';
    document.head.appendChild(qv1);

    let videoId = wistiaParam;

    _wq.push({
      id: videoId, onReady: function(video) {
        video.play();
      }
    });
  }


  //highlight pricing table column
  let pricingTable = document.querySelector('#pricing-details table');
  if(pricingTable) {
    const HOVER_CLASS = 'highlight';
    pricingTable.addEventListener("mouseover", function(e) {
      var src = e.srcElement || e.target;
      if(src.nodeName === "TD") {
        for (var i = 0; i < pricingTable.rows.length; i++) {
            pricingTable.rows[i].cells[src.cellIndex].classList.add(HOVER_CLASS);
        }
      }
      if (src.parentNode.nodeName === "TD") {
        for (var i = 0; i < pricingTable.rows.length; i++) {
            pricingTable.rows[i].cells[src.parentNode.cellIndex].classList.add(HOVER_CLASS);
        }
      }
    });

    pricingTable.addEventListener("mouseout", function(e) {
      var src = e.srcElement || e.target;
      if(src.nodeName === "TD") {
        for (var i = 0; i < pricingTable.rows.length; i++) {
          pricingTable.rows[i].cells[src.cellIndex].classList.remove(HOVER_CLASS);
        }
      }
      if(src.parentNode.nodeName === "TD") {
        for (var i = 0; i < pricingTable.rows.length; i++) {
          pricingTable.rows[i].cells[src.parentNode.cellIndex].classList.remove(HOVER_CLASS);
        }
      }
    });
  }



  var doc = document.documentElement;
  var w = window;

  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;

  var header = document.getElementById('myNavbar');

  var checkScroll = function() {

    /*
    ** Find the direction of scroll
    ** 0 - initial, 1 - up, 2 - down
    */

    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) { 
      //scrolled up
      direction = 2;
    }
    else if (curScroll < prevScroll) { 
      //scrolled down
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }
    prevScroll = curScroll;
  };

  var toggleHeader = function(direction, curScroll) {
    if (!document.querySelector('#mainNav').classList.contains('show')) {
      if (direction === 2 && curScroll > 118) {
        header.classList.add('hide');
        prevDirection = direction;
      }
      else if (direction === 1) {
        header.classList.remove('hide');
        prevDirection = direction;
      }
    }
  };
  window.addEventListener('scroll', checkScroll);

  //Non transparent once past header
  const navbar = document.querySelector(".navbar");
  const spot = document.querySelector(".hero-section");
  const firstSection  = document.querySelector("main section:first-of-type");
  const handleScroll = (entries) => {
  const spotIsVisible = entries[0].isIntersecting;
  if (spotIsVisible) navbar.classList.remove('white');
  else navbar.classList.add('white');
  };
  const options = {
    root: null,
    rootMargin: "0px",
    threshhold: 0,
  };
  const observer = new IntersectionObserver(handleScroll, options);
  if(spot) {
    observer.observe(spot);
  } else {    
    observer.observe(firstSection);
  }


  //open all external links in a new tab
  let links = document.links;
  for (var i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname != window.location.hostname && !links[i].classList.contains('login-link')) {
      links[i].target = '_blank';
      links[i].rel = 'noopener';
    }
  }

  let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  //swap out cta links for mobile
  if(isMobile) {
    let mobileSignupLinks = document.querySelectorAll('a[data-mobile-signup]');
    if(mobileSignupLinks) {
      mobileSignupLinks.forEach(function(elem) {
        //swap the link with the data-mobile-signup value
        elem.setAttribute('href', elem.dataset.mobileSignup);
        elem.removeAttribute('target');
      });
    }
  }

  //load hero video on product pages
  let homeVideo = document.querySelector('#home-hero video source');
  if(homeVideo) {
  //  if (isMobile) {
//      homeVideo.setAttribute('data-src', '/assets/home-hero-mobile.mp4');
    //} else {
      homeVideo.setAttribute('data-src', '/assets/home-hero-desktop-vw.mp4');
    //}
  }

  //load hero video on product pages
  let heroVideo = document.querySelector('#hero-bg-video source');
  if(heroVideo) {
    let mp4 = document.querySelector('#hero-bg-video');
    if (isMobile) {
      heroVideo.setAttribute('data-src', mp4.dataset.videoMobile);
    } else {
      heroVideo.setAttribute('data-src', mp4.dataset.video);
    }
  }

  //loop feature videos on hover
  /*let featureClips = document.querySelectorAll('#highlights article');
  if(featureClips) {
    featureClips.forEach(function(elem) {
        elem.addEventListener('mouseover', function(){
          elem.querySelector('video').play();
        });
        elem.addEventListener('mouseout', function(){
          elem.querySelector('video').pause();
        });
    });
  }*/

  //load carousel
  var siemaDiv = document.querySelector('.siema');
  
  if(siemaDiv){
    /*if(window.screen.width > 599) {
        var mySiema = new Siema({
        perPage: 3,
        loop: false
      });
    } else {
      var mySiema = new Siema({
        perPage: 1,
        loop: false
      });
    }*/
    if(window.screen.width > 1199) {
      var mySiema = new Siema({
        perPage: 3,
        loop: false
      });
    } else if(window.screen.width <= 1199 && window.screen.width >= 768){
      var mySiema = new Siema({
        perPage: 2,
        loop: false
      });
    } else {
      var mySiema = new Siema({
        perPage: 1,
        loop: false
      });
    }
    const prev = document.querySelector('.social-prev');
    const next = document.querySelector('.social-next');
    prev.addEventListener('click', () => mySiema.prev());
    next.addEventListener('click', () => mySiema.next());
  }

  //initialize sal.js library used for animations
  sal({
    threshold: 0.33
  });

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  //init global nav mobile collapse
  let myCollapseInit = new Collapse('button#navcollapse');


  //dropdown menus must be manually initialized
  let productDropdown = new Dropdown( '#productDropdown', true );
  let resourcesDropdown = new Dropdown( '#resourcesDropdown', true );
  if(document.querySelector('#langDropdown')) {
    let langDropdown = new Dropdown( '#langDropdown', true );
  }

  //pricing page annual/monthly price toggler
  const el = document.querySelector('#annual-toggle');
  const pricingSummary = document.querySelector('#pricing-summary');
  if(el) {
    el.onclick = function() {
      el.classList.toggle('active');
      pricingSummary.classList.toggle('annual');
    }
  }

  //New agencies competitors pricing accordion
  let competitorsRows = document.querySelectorAll('.competitor-row');
  if(competitorsRows.length > 0) {
    competitorsRows.forEach(item => {
      item.addEventListener('mouseenter', event => {
        item.classList.toggle('open-pricing');
      })
      item.addEventListener('mouseleave', event => {
        item.classList.toggle('open-pricing', false);
      })
    })  
  }

  //FAQ accordion
  let faqRows = document.querySelectorAll('.faq-row');
  const moreQuestionsBtn = document.querySelector('.more-questions-button');

  if(faqRows.length > 0) {
    if(faqRows.length < 5) {
      moreQuestionsBtn.style.display = 'none';
    }
    faqRows.forEach(item => {
      item.addEventListener('click', event => {
        item.classList.toggle('open-faq');
      })
    })  

    //FAQ more
    if(moreQuestionsBtn) {
      moreQuestionsBtn.addEventListener('click', event => {
        event.preventDefault();
        moreQuestionsBtn.style.display = 'none';
        document.querySelector('#faqs .module.partial-faq').classList.remove('partial-faq');
      });
    }
  }
  //Screenshots accordion
  const panels = document.querySelectorAll('.feature-row');
  let openedPanel = document.querySelectorAll('.open-feature')[0];

  async function toggleOpen() {
    let currentPanel = document.querySelectorAll('.open-feature')[0];

    if(!this.classList.contains('open-feature')) {

      if (openedPanel)
        openedPanel.classList.remove('open-feature');
      this.classList.add('open-feature');
      openedPanel = this;
      let featureImg = openedPanel.getAttribute('data-feature-img');
      let featureSkin = openedPanel.getAttribute('data-feature-skin');
      let currentSkin = currentPanel.getAttribute('data-feature-skin');
      let screenshots = document.querySelectorAll('.screenshot');
      let widget = document.querySelector('#home-features');
      let accent = document.querySelector('.bottom-accent');
      screenshots.forEach(function(el) {
        el.style.opacity = 0;
        el.style.transform = 'translateX(20%)';
      });

      if(typeof(featureSkin) != 'undefined' && featureSkin != null){
        accent.style.transform = 'scale(0)';
        await sleep(800);
        screenshots.forEach(function(el) {
          el.style.backgroundImage = 'url('+featureImg+')';
        });
        await sleep(600);
        widget.classList = featureSkin + ' buddy-' + featureSkin;
        screenshots.forEach(function(el) {
          el.style.opacity = 1;
          el.style.transform = 'none';
        });

        accent.style.opacity = 1;
        accent.style.transform = 'none';

      } else {
        await sleep(800);
        screenshots.forEach(function(el) {
          el.style.backgroundImage = 'url('+featureImg+')';
        });

        await sleep(600);
        screenshots.forEach(function(el) {
          el.style.opacity = 1;
          el.style.transform = 'none';
        });
      }
    }
  };
  panels.forEach(panel => panel.addEventListener('click', toggleOpen));


  //init tooltip on all elements with title attribute
  let elementsTooltip = document.querySelectorAll('.has-tooltip[title]');
  // attach a tooltip for each
  Array.from(elementsTooltip).map(
    tip => new Tooltip( tip, {
      placement: 'bottom',
      animation: 'slideNfade',
      delay: 200,
    })
  )


  /* TRAKING COOKIES */

  var parseQueryString = function(queryString) {
      var params = {}, queries, temp, i, l;

      // Split into key/value pairs
      queries = queryString.split("&");

      // Convert the array of strings into an object
      for ( i = 0, l = queries.length; i < l; i++ ) {
          temp = queries[i].split('=');
          params[temp[0]] = temp[1];
      }

      return params;
  };

  var createCookie = function(name, value, days, domain) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      expires = "; expires="+date.toGMTString();
    }
    document.cookie = name+"="+value+expires+"; domain="+domain+"; path=/";
  }

  var readCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  var queryString = document.location.search;
  if (queryString.length > 0) {
    queryString = queryString.substring(1);
  }

  // Track ambassadors
  var queryParams = parseQueryString(queryString);
  if (queryParams['mbsy']) {
    createCookie('mbsy', queryParams['mbsy'], 90, 'agorapulse.com');
  }
  var ambassadorCookie = readCookie('mbsy');

  // Track acquisition channels
  var acquisitionSourceCookie = readCookie('acquisition_source');
  if (!acquisitionSourceCookie && document.referrer.search('https?://(.*)www.agorapulse.([^/?]*)') !== 0) {
    var acquisitionMedium = '';
    var acquisitionSource = '';
    var referrer = document.referrer;

    // Acquisition source
    if (queryParams['utm_source'] && referrer.search('https?://(.*)agorapulse.([^/?]*)') !== 0) { // Ignore legacy utm from barometer/contest
      acquisitionSource = queryParams['utm_source'];
    } else if (referrer.length > 0) {
      if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
        acquisitionSource = 'google';
      } else if (referrer.search('https?://(.*)bing.([^/?]*)') === 0) {
        acquisitionSource = 'bing';
      } else if (referrer.search('https?://(.*)yahoo.([^/?]*)') === 0) {
        acquisitionSource = 'yahoo';
      } else if (referrer.search('https?://(.*)facebook.([^/?]*)') === 0 || referrer.search('https?://(.*)fb.me.([^/?]*)') === 0) {
        acquisitionSource = 'facebook';
      } else if (referrer.search('https?://(.*)twitter.([^/?]*)') === 0 || referrer.search('https?://(.*)t.co.([^/?]*)') === 0) {
        acquisitionSource = 'twitter';
      } else if (referrer.search('https?://(.*)linkedin.([^/?]*)') === 0 || referrer.search('https?://(.*)lnkd.in.([^/?]*)') === 0) {
        acquisitionSource = 'linkedin';
      } else if (referrer.search('https?://(.*)plus.google.([^/?]*)') === 0) {
        acquisitionSource = 'google+';
      } else if (referrer.search('https?://(.*)pinterest.([^/?]*)') === 0) {
        acquisitionSource = 'pinterest';
      } else if (referrer.search('https?://(.*)instagram.([^/?]*)') === 0) {
        acquisitionSource = 'instagram';
      } else if (referrer.search('https?://(.*)agorapulse.([^/?]*)') === 0) {
        acquisitionSource = 'agorapulse';
      }
    }

    if (queryParams['utm_medium']) {
      acquisitionMedium = queryParams['utm_medium'];
    } else if (acquisitionSource === 'google'
                || acquisitionSource === 'bing'
                || acquisitionSource === 'yahoo') {
      if (document.location.pathname.indexOf('/blog') > -1) {
        acquisitionMedium = 'organic-blog';
      } else {
        acquisitionMedium = 'organic';
      }
    } else if (acquisitionSource === 'facebook'
                || acquisitionSource === 'twitter'
                || acquisitionSource === 'linkedin'
                || acquisitionSource === 'google+'
                || acquisitionSource === 'pinterest'
                || acquisitionSource === 'instagram'
          || acquisitionSource === 'agorapulse') {
      if (document.location.pathname.indexOf('/blog') > -1) {
        acquisitionMedium = 'referral-blog';
      } else {
        acquisitionMedium = 'referral';
      }
    }

    if (acquisitionSource !== '' && acquisitionMedium !== '') {
      createCookie('acquisition_source', acquisitionSource, 90, 'agorapulse.com');
      createCookie('acquisition_medium', acquisitionMedium, 90, 'agorapulse.com');
    }
  }


  
});